/* eslint-disable import/prefer-default-export */
export const KYCVerificationStatus = {
  DETAILS_ADDED: "details_added", // when creator just started filling details
  UNDER_REVIEW: "under_review", // automatically switched to this (INDIAN -> both pan and aadhar is there) & (INTL -> both passport and residency is there)
  VERIFIED: "verified", // controlled from admin
  REJECTED: "rejected", // controlled from admin
};
